import React from 'react';
import styled from 'styled-components';

export const Flex = ({
  column = false,
  justifyContent = 'center',
  alignItems = 'center',
  wrap,
  width,
  height,
  padding,
  children,
  ...props
}) => {
  return (
    <FlexStyle
      column={column}
      justifyContent={justifyContent}
      alignItems={alignItems}
      wrap={wrap}
      width={width}
      height={height}
      padding={padding}
      {...props}
    >
      {children}
    </FlexStyle>
  );
};

const FlexStyle = styled.div`
  display: flex;
  flex-direction:${(props) => (props.column ? 'column' : 'row')}
  justify-content: ${(props) => props.justifyContent};
  align-items: ${(props) => props.alignItems};
  flex-wrap: ${(props) => (props.wrap ? 'wrap' : 'nowrap')};
  width: ${(props) => props.width};
  height: ${(props) => props.height};
  padding: ${(props) => props.padding || 0};
`;

export const GreyContainer = styled(Flex)`
  background: ${(props) => props.theme.background.grey};
  padding: calc(2000% / 375);
  width: 100%;
`;
